module.exports = __webpack_public_path__ + "img/VietQR.e62288e9.svg";